import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export interface AddressViewResult {
    idx: number;
    c_code: string;
    a_company: string;
    a_tel: string;
    a_name: string | null;
    a_mobile: string | null;
    a_post: string;
    a_address: string;
    a_address_detail: string | null;
}

export interface AddressViewResponse {
    statusCode: number;
    message: string;
    data: AddressViewResult;
}

export const useGetAddressView = (idx?: string): UseQueryResult<AddressViewResult, Error> => {
    return useQuery({
        queryKey: ["useGetAddressView", idx],
        queryFn: async () => {
            const { data } = await axiosInstance.get<AddressViewResponse>(`${enum_api_uri.get_address_view}`, {
                params: { idx },
            });
            return data.data;
        },
        enabled: !!idx,
    });
};
